import CurrencyText from "../../../../components/fragment/cur-text/CurrencyText";
import NumberInput from "./NumberInput";

export interface QualifyingThresholdValue {
  referral: string;
  referee: string;
}

interface QualifyingThresholdTableProps {
  currencies: any[];
  values: Record<string, QualifyingThresholdValue>;
  onChange: (
    code: string,
    field: keyof QualifyingThresholdValue,
    nextValue: string,
  ) => void;
  disabled?: boolean;
}

export default function QualifyingThresholdTable({
  currencies,
  values,
  onChange,
  disabled,
}: QualifyingThresholdTableProps) {
  return (
    <div className="mt-[24px]">
      <div className="grid grid-cols-[180px_220px_220px] gap-[16px] px-[16px] text-[14px] font-bold text-[#5C70AF]">
        <span>Currency</span>
        <span>Referrer Amount</span>
        <span>Referee Amount</span>
      </div>
      <div className="mt-[8px] space-y-[8px]">
        {(currencies || [])
          .filter((currency) => currency?.code)
          .map((currency) => {
          const value = values[currency.code] || { referral: "", referee: "" };
          return (
            <div
              key={currency.code}
              className="grid grid-cols-[180px_220px_220px] items-center gap-[16px] rounded-[8px] bg-[#F4F4F5] px-[16px] py-[12px]"
            >
              <CurrencyText
                currency={currency.code}
                text={currency?.name}
                imgSize="20px"
              />
              <NumberInput
                thousandSeparator
                disabled={disabled}
                value={value.referral}
                onChange={(e) =>
                  onChange(currency.code, "referral", e.target.value)
                }
                className="h-[36px] w-full rounded-[6px] border border-[#E4E4E7] bg-white px-[10px] text-[16px] text-[#A1A1AA] outline-none focus:border-[#734792] disabled:opacity-60"
              />
              <NumberInput
                thousandSeparator
                disabled={disabled}
                value={value.referee}
                onChange={(e) =>
                  onChange(currency.code, "referee", e.target.value)
                }
                className="h-[36px] w-full rounded-[6px] border border-[#E4E4E7] bg-white px-[10px] text-[16px] text-[#A1A1AA] outline-none focus:border-[#734792] disabled:opacity-60"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
